const variables = {
	textColour: '#333333',
	themeColour: '#037EF3',
	lightRed: '#E85D5E',
	red: '#CF424F',
	y2bGreen: '#30C39F',
	hoverColour: '#4EA8FD',
	shadow: `box-shadow: 0 6px 20px rgba(75, 97, 141, 0.3);
          -webkit-box-shadow: 0 6px 20px rgba(75, 97, 141, 0.3);`,
	buttonShadow: `box-shadow: 0 4px 4px rgba(75, 97, 141, 0.3);
          -webkit-box-shadow: 0 4px 4px rgba(75, 97, 141, 0.3);`,
	blueShadow: `box-shadow: 0 6px 20px rgba(3, 126, 243, 0.3);
              -webkit-box-shadow: 0 6px 20px rgba(3, 126, 243, 0.3);`,
	highlight: 'box-shadow: white 0px -0.105em inset, rgb(255, 206, 51, 0.75) 0px -0.65em inset;',
}

export default variables
